import NAME from "./constants";

export const getRows = store => store[NAME].rows;
export const getLoading = store => store[NAME].loading;
export const getCodeRefTypes = store => store[NAME].codeRefTypes;
export const getColumnTypes = store => store[NAME].columnTypes;
export const getCalculationIndicatorTypes = store => store[NAME].calculationIndicatorTypes;
export const getInformedValueTypeTypes = store => store[NAME].informedValueTypeTypes;
export const getConcepts = store => store[NAME].concepts;
export const getEntryModeTypes = store => store[NAME].entryModeTypes;